import { SET_USER_LOGIN } from '../actions/loggedUser';
import { buildLoggedUser } from '../helpers/loggedUser';
import { buildUser } from '../../users/helpers/users';
const initialState = {
    fetching: false,
    user: {
        permission: {},
        permisionEntities: {}
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_LOGIN: {
            return {
                ...state,
                fetching: false,
                user: {
                    ...buildLoggedUser(buildUser(action.payload.user, action.payload.profiles)),
                    permission: action.payload.permission,
                    permisionEntities: action.payload.permisionEntities
                }
            };
        }
        default:
            return state;
    }
};
